var React = require('react');

function SliderDot (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"10","cy":"10","r":"10","fill":"black"}));
}

SliderDot.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = SliderDot;

SliderDot.default = SliderDot;
